import { BrowserMultiFormatReader } from "@zxing/browser";

export const BarcodeHook = {
  async mounted() {
    const buttonEl = this.el.querySelector(":scope button");
    const closeButtonEl = this.el.querySelector(":scope .preview-close");
    const inputEl = this.el.querySelector(":scope input");
    const previewWrapperEl = this.el.querySelector(":scope .preview-wrapper");
    const previewEl = this.el.querySelector(":scope .preview");
    const readerBoxEl = this.el.querySelector(":scope .reader-box");

    let capturing = true;
    const codeReader = new BrowserMultiFormatReader();

    const startCamera = async (video) => {
      const constraints = {
        audio: false,
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1920 },
        },
      };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      previewEl.srcObject = stream;
      await previewEl.play();
      return stream;
    };

    const startBarcodeDecode = (video, reader, stream, onResult) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      let lastFrame = 0;
      capturing = true;

      const decodeFrame = async () => {
        const vw = video.videoWidth;
        const vh = video.videoHeight;
        if (!vw || !vh) return;

        // Center capture zone: ~80% width x 40% height
        // This is matching the red div dimensions (w-8/10 and h-4/10)
        const captureW = Math.floor(vw * 0.8);
        const captureH = Math.floor(vh * 0.3);
        const sx = Math.floor((vw - captureW) / 2);
        const sy = Math.floor((vh - captureH) / 2);

        canvas.width = captureW;
        canvas.height = captureH;
        ctx.drawImage(video, sx, sy, captureW, captureH, 0, 0, captureW, captureH);

        try {
          const result = await reader.decodeFromCanvas(canvas);
          if (result?.text) {
            capturing = false;
            onResult(result.text, stream);
          }
        } catch (e) {
          // no code found
        }
      };

      const loop = (currentFrame) => {
        if (!capturing) return;
        requestAnimationFrame(loop);
        // Throttle to ~10 fps so autofocus can settle
        if (currentFrame - lastFrame < 100) return;
        lastFrame = currentFrame;
        decodeFrame();
      };
      requestAnimationFrame(loop);
    };

    const stopCapture = (stream, previewWrapperEl) => {
      previewWrapperEl.classList.add("hidden");
      previewWrapperEl.classList.remove("flex");
      readerBoxEl.classList.add("bg-red-500/30", "border-red-500");
      readerBoxEl.classList.remove("bg-green-500/30", "border-green-500");
      for (const track of stream.getTracks()) {
        track.stop();
      }
    };

    buttonEl.addEventListener("click", async (e) => {
      previewWrapperEl.classList.remove("hidden");
      previewWrapperEl.classList.add("flex");

      const stream = await startCamera();

      const onResult = (text, stream) => {
        inputEl.value = text;
        inputEl.dispatchEvent(new Event("input", { bubbles: true }));
        setTimeout(() => stopCapture(stream, previewWrapperEl), 500);
        readerBoxEl.classList.remove("bg-red-500/30", "border-red-500");
        readerBoxEl.classList.add("bg-green-500/30", "border-green-500");
      };

      startBarcodeDecode(previewEl, codeReader, stream, onResult);

      closeButtonEl.addEventListener("click", (e) => {
        stopCapture(stream, previewWrapperEl);
        capturing = false;
      });
    });
  },
};
